import { Language } from 'src/lib/utils'

export const I18nResource = {
  [Language.EN]: 'en.json',
  [Language.ES]: 'es.json',
  [Language.PT]: 'pt_BR.json'
}
